<template>
  <span>
    <span v-if="!iconOnly && isMultiline" class="sensitive-multiline">
      <span v-for="(line, index) in masked" :key="index">{{ line }}</span>
    </span>
    <span v-else-if="!iconOnly">{{ displayValue }}</span>
    <vs-icon
      v-if="(hasValue || iconOnly) && reveal"
      class="ml-2 cursor-pointer"
      icon-pack="feather"
      icon="icon-eye-off"
      title="Visualizar dado completo"
      :data-testid="`sensitive-reveal-${label}`"
      @click.native.stop="openModal"
      @click.stop="openModal"
    />
    <vs-popup title="Visualizar" :active.sync="modalActive">
      <p>
        <span class="font-semibold">{{ label }}: </span
        ><span :data-testid="`sensitive-revealed-${label}`">{{
          revealedValue
        }}</span>
      </p>
    </vs-popup>
  </span>
</template>

<script>
export default {
  name: 'SensitiveField',
  props: {
    masked: {
      type: [String, Number, Array],
      default: null,
    },
    reveal: {
      type: Function,
      default: null,
    },
    label: {
      type: String,
    },
    emptyText: {
      type: String,
      default: '',
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalActive: false,
      revealedValue: null,
    };
  },
  computed: {
    isMultiline() {
      return Array.isArray(this.masked);
    },
    hasValue() {
      if (this.isMultiline) {
        return this.masked.length > 0;
      }
      return (
        this.masked !== null && this.masked !== undefined && this.masked !== ''
      );
    },
    displayValue() {
      return this.hasValue ? this.masked : this.emptyText;
    },
  },
  methods: {
    async openModal() {
      if (!this.reveal) {
        return;
      }
      try {
        this.revealedValue = await this.reveal();
        this.modalActive = true;
      } catch (error) {
        this.$vs.notify({
          title: 'Falha ao visualizar dado',
          text: 'Não foi possível carregar o dado completo.',
          color: 'danger',
          position: 'top-center',
        });
      }
    },
  },
};
</script>

<style scoped>
.sensitive-multiline > span:not(:first-child)::before {
  content: '\A';
  white-space: pre;
}
</style>
